const Insignias = ({ insignias }) => {
  const activeColors = [
    'bg-orange-200 text-orange-800',
    'bg-blue-100 text-blue-800',
    'bg-green-100 text-green-800'
  ];

  return (
      <div className="profile-badges mb-4">
      <div className="flex flex-wrap gap-2 justify-center">
        {insignias?.map((badge, index) => (
          <span key={index} className={`text-xs px-4 py-1 rounded-full
          ${badge?.active ? `${activeColors[index % activeColors.length]} font-semibold` : "bg-gray-100 text-gray-500"}`}>
            {badge?.insignia.split(" ")[0]}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Insignias;
